import { DatagridVisualisationEnum } from '@app/core/enums/datagrid-visualisation.enum';
import { EntityTypeEnum } from '@app/core/enums/entity-type.enum';
import { AbstractBean } from '@app/core/model/abstract-bean';
import { ColumnState } from 'ag-grid-community';
import { Expose } from 'class-transformer';

export class DatagridVisualisation extends AbstractBean {
  public objectType = EntityTypeEnum.DATAGRID_VISUALISATION;

  public datagrid: DatagridVisualisationEnum;
  public organizationId: string;
  public config: DatagridVisualisationConfig;
  public isDefault: boolean;
  public assetTypeId: string;
  public userId: number | null;

  /**
   * Whether the visualisation is shared with the whole organization (including default visualisations).
   * @return {boolean} true when the visualisation is not owned by a specific user
   */
  public get isShared(): boolean {
    return this.userId == null;
  }

  @Expose()
  public toString(): string {
    return this.name;
  }

  /**
   * Return a deep copy of the visualisation.
   * @return {DatagridVisualisation}
   */
  public copy(): this {
    return structuredClone(this);
  }
}

export interface DatagridVisualisationConfig {
  columnState?: ColumnState[];
  filterModel?: { [key: string]: any };
}
